import mutations from './mutations';
import actions from './actions';
// import moment from 'moment';

export default {
  namespaced: true,
  modules: {
  },
  state: {
    users: [],
    singleUser: false,
    permissions: [],
    roles: [],
    deleted_user: {
      data: {},
      status: 'loading'
    },
    updated_user: {
      data: {},
      status: 'loading'
    },
    password_change: {
      data: {},
      status: 'loading'
    }
  },
  getters: {
    users: (state) => {
      return state.users;
    },
    permissions: (state) => {
      return state.permissions;
    },
    roles: (state) => {
      return state.roles;
    },
    singleUser: (state) => {
      return state.singleUser;
    },
    deleted_user: (state) => {
      return state.deleted_user;
    },
    updated_user: (state) => {
      return state.updated_user;
    },
    password_change: (state) => {
      return state.password_change;
    }
  },    
  mutations,
  actions
};
